<div class="flex flex-col mb-6">
  <div class="font-syne text-2xl font-semibold mb-5">Tilvalgsdækninger</div>

  <ng-container *ngFor="let cover of ksfCoverages; let i = index">
    <ng-container *ngIf="cover.id !== 10071 && cover.id !== 10072">
      <div
        (click)="setSelectedCovers(i)"
        [ngClass]="
          this.ksfTemplate.covers[i].Selected
            ? 'border-[#32C895] bg-[#F1FCF9]'
            : 'border-gray-300 bg-transparent'
        "
        class="my-2 flex flex-wrap justify-between border shadow p-5 rounded-xl cursor-pointer"
      >
        <div class="flex items-center justify-center">
          <i
            [ngClass]="
              this.ksfTemplate.covers[i].Selected
                ? 'text-teal-450'
                : 'text-gray-200'
            "
            class="fa-solid fa-circle-check mr-3 text-xl"
          ></i>
          <p class="font-semibold font-syne text-base">
            {{ cover.publicName }}
          </p>
        </div>

        <!-- Pricing and Tooltip Div -->
        <div class="flex items-center">
          <div class="flex items-center truncate">
            <p
              [ngClass]="{
                'quantico-text': this.ksfTemplate.covers[i].Selected,
              }"
              class="text-2xl quantico-font ml-8 truncate"
            >
              <span *ngIf="showYearlyPrice">
                {{ cover.coverPremium | formatNumber }}
              </span>
              <span *ngIf="!showYearlyPrice">
                {{ cover.coverPremium / 12 | formatNumber }}
              </span>
              <span class="text-xs" *ngIf="showYearlyPrice">DKK/år</span>
              <span class="text-xs" *ngIf="!showYearlyPrice">DKK/md.</span>
            </p>

            <!-- Info Icon Tooltip -->
          </div>
          <div class="relative">
            <i
              (mouseover)="toggleTooltip(i, true)"
              (mouseout)="toggleTooltip(i, false)"
              class="fas fa-regular fa-circle-info text-gray-300 ml-4"
            ></i>
            <!-- Tooltip Content -->
            <span
              class="text-sm z-10 bg-white border shadow-lg rounded-md absolute bottom-full left-1/2 transform -translate-x-1/2 px-6 py-4 w-96"
              [class.hidden]="!tooltipVisibility[i]"
            >
              <p class="font-medium mb-4">{{ cover.publicName }}</p>
              <p class="mb-2 text-xs">{{ cover.description }}</p>
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- #### Mersalg ####-->
  <div
    *ngIf="
      (vehicleFromDmr.fuelType == 'El' ||
        vehicleFromDmr.pluginHybrid == true) &&
      allHaveToggleChargingStandAllowed
    "
    class="mt-6"
  >
    <div class="font-syne text-2xl font-semibold mb-5">Flere tilvalg</div>

    <div
      (click)="toggleChargingStandCoverage()"
      [ngClass]="{ 'border-[#32C895] bg-[#F1FCF9]': chargingStand }"
      class="my-2 border shadow p-5 rounded-xl cursor-pointer"
    >
      <div class="flex">
        <i
          [ngClass]="chargingStand ? 'text-teal-450' : 'text-gray-200'"
          class="fa-solid fa-circle-check mr-4 text-2xl"
        ></i>
        <div>
          <p class="font-semibold">Ladestander</p>
          <ng-container *ngIf="textDirectedToCustomer; else dealerDirectedText">
            <p class="text-gray-500">Få et uforpligtende tilbud på en ladeløsning</p>
            <p class="text-gray-500">
              Du vil blive ringet op af Energi Fyn inden for få hverdagen
            </p>
          </ng-container>
          <ng-template #dealerDirectedText>
            <p class="text-gray-500">
              Få et uforpligtet tilbud på en ladeløsning.
            </p>
            <p class="text-gray-500">
              Din kunde vil blive ringet op af Energi Fyn inden for 1-2 hverdage.
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<button
  (click)="nextStep()"
  type="button"
  class="py-3 px-4 shadow-lg font-inter inline-flex items-center gap-x-1 text-sm rounded-full border border-transparent bg-teal-450 text-white hover:bg-teal-500 disabled:opacity-50 disabled:pointer-events-none"
>
  Næste
</button>
